import dayjs from 'dayjs';
import {useTranslation} from 'react-i18next';

import {Typography} from '@/components/ui/typography';
import {TIME_FORMATS} from '@/utils/timeFormats';

export type PrintHeaderProps = {
  title: string;
  description?: string;
  createdAt: string;
};

export const PrintHeader = ({
  title,
  description,
  createdAt,
}: PrintHeaderProps) => {
  const {t} = useTranslation();

  return (
    <div className="border-b border-border pb-4">
      <Typography variant="h1" asChild className="text-2xl font-bold">
        <h1>{title}</h1>
      </Typography>
      {description && (
        <Typography className="text-sm">{description}</Typography>
      )}
      <Typography className="text-sm text-muted-foreground">
        {t('Generated at')}: {dayjs(createdAt).format(TIME_FORMATS.dateTime)}
      </Typography>
    </div>
  );
};
